import Canvas from "./components/Canvas";

const App = () => {
  return <Canvas />;
};

export default App;
